var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOnBack = function SvgOnBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.27857 6.73193L11.3801 6.73193C11.7225 6.73193 12 6.42208 12 6.04073L12 6.00234C12 5.62099 11.7225 5.31114 11.3801 5.31114L2.26322 5.31114L6.13073 1.1853C6.36924 0.916505 6.45486 0.471591 6.21634 0.202792L6.21162 0.197496C5.97311 -0.071303 5.49902 -0.0620287 5.25697 0.202798L5.25106 0.209418L0.0894444 5.7918C-0.0298148 5.92618 -0.0298148 6.14337 0.0894444 6.27775L0.747127 7.01795L5.19793 11.7979C5.4388 12.0693 5.92322 12.0654 6.16645 11.7979L6.17118 11.7926L6.19125 11.7701C6.43094 11.5013 6.33972 11.0723 6.10003 10.8035L2.27857 6.73193Z",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 2 2)",
    fill: "currentColor"
  })));
};
export default SvgOnBack;